import { forwardRef, type Ref, type SVGProps } from "react";
const IconLinkedInSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28.13 2H3.87A1.87 1.87 0 0 0 2 3.87v24.26A1.87 1.87 0 0 0 3.87 30h24.26A1.87 1.87 0 0 0 30 28.13V3.87A1.87 1.87 0 0 0 28.13 2M10.29 25.89H6.08V12.5h4.21zm-2.1-15.23a2.45 2.45 0 1 1 2.46-2.45 2.45 2.45 0 0 1-2.46 2.45m17.72 15.23h-4.12v-6.48c0-1.57 0-3.5-2.2-3.5s-2.45 1.67-2.45 3.41V26H13V12.5h3.86v1.84H17a4.39 4.39 0 0 1 3.95-2.19c4.21 0 5 2.8 5 6.39z" />
  </svg>
);
const ForwardRef = forwardRef(IconLinkedInSVG);
ForwardRef.displayName = "IconLinkedIn";
export { ForwardRef as IconLinkedIn };
